export enum AggregationMode {
    None,
    Average,
    Sum,
    Minimum,
    Maximum,
    First,
    Last,
    StdDev,
    Delta,
    Integration
}